<script setup>
import { computed, ref, watch } from "vue";

const props = defineProps({
  photo: { type: [Object, String], default: null },
  initials: { type: String, default: "" },
  tone: { type: String, default: "#96634d" },
});
const failed = ref(false);
const imageUrl = computed(() => {
  const contentUrl = typeof props.photo === "object" ? props.photo?.contentUrl : props.photo;
  if (!contentUrl) return "";
  if (/^https?:\/\//i.test(contentUrl)) return contentUrl;
  const baseUrl = (process.env.VUE_APP_BASE_URI || "").replace(/\/$/, "");
  if (contentUrl.startsWith("/")) return baseUrl + contentUrl;
  return baseUrl + "/images/employees/" + contentUrl;
});
watch(imageUrl, () => { failed.value = false; });
</script>

<template>
  <span class="security-user-avatar" :style="{ backgroundColor: tone }">
    <img v-if="imageUrl && !failed" :src="imageUrl" alt="" @error="failed = true" />
    <template v-else>{{ initials }}</template>
  </span>
</template>

<style scoped lang="scss">
.security-user-avatar {
  align-items: center;
  border: 2px solid #474ce6;
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  flex: 0 0 34px;
  font-size: .65rem;
  font-weight: 800;
  height: 34px;
  justify-content: center;
  overflow: hidden;
  width: 34px;
}

.security-user-avatar img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}
</style>
